<template>
	<div class="search-wrapper">
		<BaseInput
			:value="props.modelValue"
			v-bind="$attrs"
			placeholder="Search"
			class="search-input"
			@input="emit('update:modelValue', ($event.target as HTMLInputElement).value)"
		/>
		<MagnifierIcon class="search-icon" />
	</div>
</template>

<script setup lang="ts">
import MagnifierIcon from '@/assets/icons/magnifier.svg?component';
import BaseInput from './BaseInput.vue';

const props = defineProps<{
	modelValue?: string;
}>();

const emit = defineEmits(['update:modelValue']);
</script>

<style>
.search-wrapper {
	position: relative;
}

.search-icon {
	position: absolute;
	top: 12px;
	left: 12px;
	width: 18px;
	height: 18px;
}

.search-input {
	padding: 11px 12px !important;
	padding-left: 36px !important;

	gap: 6px;

	font-family: 'Exo 2';
	font-style: normal;
	font-weight: 400;
	font-size: 14px;
	line-height: 17px;
}
</style>
